import { IActionContext } from '@msdyn365-commerce/core';
import { IPredefinedRefinerHandler } from '../predefined-refiners';

export function getHandler(context: IActionContext): IPredefinedRefinerHandler | undefined {
    return {
        apply: (refiner) => {
            refiner.Values = refiner.Values.filter((value) => {
                return value.LeftValueBoundString !== 'Ingen' && value.LeftValueBoundString !== 'None';
            });
        },
        isMatch: (refiner) => {
            return refiner.KeyName === 'Konsept' || refiner.KeyName === 'Concept';
        }
    };
}
